firebird.directive('toggle', [
    'helperService',
    function (helperService) {
        return {
            restrict: 'A',
            scope: {
                tooltipOptions: '=tooltipOptions'
            },
            link: function (scope, element, attrs) {
                if (helperService.isMobile() || helperService.getDeviceType() === 'Android') {
                    return;
                }

                const opts = scope.tooltipOptions || {};
                const x = attrs.toggle;

                attrs.$observe('tooltipHide', function (newValue) {
                    if (newValue === 'true') {
                        element.tooltip('hide');
                        element.tooltip('disable');
                    } else if (newValue === 'false') {
                        element.tooltip('enable');
                    }
                });

                attrs.$observe('placement', newValue => {
                    element.data('bs.tooltip').options.placement = newValue;
                });

                attrs.$observe('customClass', newValue => {
                    element.data('bs.tooltip').options.customClass = newValue;
                });

                //Tooltip
                if (x === 'tooltip') {
                    element.tooltip(opts);

                    element.on('click', function () {
                        element.tooltip('hide');
                    });
                }

                //Popover
                if (x === 'popover') {
                    element.popover(opts);
                }
                element.on('$destroy', function () {
                    element.tooltip('hide');
                });
            }
        };
    }
]);
